import _ from 'lodash';
import {
  getByModelAndKey,
  NAV_ITEM_COUNT,
  PROGRESS,
  PROGRESS_ARRAY,
  setByModelAndKey
} from '../../resources/localStorage/localStorage.service';

export const setProgress = value => {
  const appResources = window.appResources;
  const totalTabs = getByModelAndKey(appResources, NAV_ITEM_COUNT) || 0;
  let totalProgress = getByModelAndKey(appResources, PROGRESS_ARRAY) || [];

  if (!_.includes(totalProgress, value)) {
    totalProgress.push(value);
    setByModelAndKey(appResources, PROGRESS_ARRAY, totalProgress);
  }

  if (_.includes(totalProgress, 'SUMMARY')) {
    setByModelAndKey(appResources, PROGRESS, 100);
  } else {
    const percentage = totalTabs === 0 ? 0 : totalProgress.length / totalTabs;

    setByModelAndKey(
      appResources,
      PROGRESS,
      (Math.floor(percentage * 4) / 4).toFixed(2) * 100
    );
  }
};

export const setTotalTabs = count => {
  setByModelAndKey(window.appResources, NAV_ITEM_COUNT, count);
};

export const getVisitedTabs = () =>
  getByModelAndKey(window.appResources, PROGRESS_ARRAY) || [];
